var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var SubItems = (function (_super) {
    __extends(SubItems, _super);
    function SubItems() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubItems.prototype.render = function () {
        return (React.createElement("ul", null, this.props.children));
    };
    return SubItems;
}(React.Component));
export default SubItems;
//# sourceMappingURL=subitems.js.map